import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/ui/flex'
import { Typography } from '@/components/ui/typography'

import { PlaceFeatureWarning, PlaceFeatureWarningId } from '../../features/places-features.rules'

interface PlaceSaveWarningsProps {
  warnings: PlaceFeatureWarning[]
}

export const PlaceSaveWarnings = ({ warnings }: PlaceSaveWarningsProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <Flex direction="column" gap={12}>
      {warnings.map((warning) => (
        <Flex key={warning.id} direction="column" gap={4}>
          <Typography size="text-medium" color="black800">
            {t(`organisation:places.save.warnings.${warning.id}`)}
          </Typography>
          {warning.id === PlaceFeatureWarningId.cascadeOff && (
            <ul>
              {warning.features.map((feature) => (
                <li key={feature}>
                  <Typography size="text-small" color="black500">
                    {t(`organisation:places.building.toggles.${feature}`)}
                  </Typography>
                </li>
              ))}
            </ul>
          )}
        </Flex>
      ))}
    </Flex>
  )
}
